import Typography from "@mui/material/Typography";
import styles from "../../common/user/user.module.scss";
import commonStyles from "../../../App.module.scss";
import { Box, Card, Grid } from "@mui/material";
import { useState, useRef, useEffect } from "react";
import {
  CustomTextFeild,
  CustomRequiredInputLabel,
  CustomCalendarTodayOutlinedIcon,
  CustomDatePicker,
  StyledDateContainer,
  CustomLeftIcon,
  CommonOutlinedButton,
  CommonButton,
} from "../../common/StyledComponents/StyledFields";
import { useNavigate, useSearchParams } from "react-router-dom";
import constants from "../../../config/constants.json";
import {
  apiRequest,
  authService,
  catchErrorMessageHandler,
  checkAuthToken,
  getDevoteeId,
  getUserName,
  getUserSelectedRole,
  getaccessToken,
} from "../../../infrastructure/backendService";
import { object, string, ref, ValidationError } from "yup";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { AxiosResponse, AxiosError } from "axios";
import apiPath from "../../../config/apiPaths.json";
import ToastError from "../../common/toast/toastError";
import toast, { Toaster } from "react-hot-toast";
import { isNil } from "lodash";
import SuccessComponent from "../../volunteerRegistration/successComponent/successComponent";
import { ClipLoader } from "react-spinners";
import SuccessPopup from "../../devotee/donation/successPopup";
import ErrorPopup from "../../common/ErrorPopup";
import { cartItemListProps } from "../../../infrastructure/GlobalContextProvider";
import { RoutingURLs } from "../../common/RoutingURLs";
import PaymentCancelConfirmationDialog from "../../PaymentCancelConfirmation/PaymentCancelConfirmation";

interface originalPayload {
    bookedItemInCart: {
      id: number;
      type: string;
      dateOfPooja: Date | null;
      priestName: string;
      poojaOrHallName: string;
      deities: any[]; // or specify the type of 'deities' if known
      donationPurpose: string;
      description: string;
      amount: number;
      tangibleAmount: number;
    }[];
    totalAmount: number;
    totalTanAmount: number;
  }

interface ErrorMessageTypes {
  payPalTransactionId: string;
  transctionDate: string;
}
interface ManagerPayPalProps {
  setSelectedPaymentMode?: React.Dispatch<React.SetStateAction<string>>;
  amount?: number;
  setShowPayment?: React.Dispatch<React.SetStateAction<boolean>>;
  setShowSuccess?: React.Dispatch<React.SetStateAction<boolean>>;
  cartItemsList: cartItemListProps[];
  navigateBack?: () =>  void;
}

export default function ManagerPayPalCartItems(props: ManagerPayPalProps) {

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  const hasManagerLevelRole = constants.showDashBoardForRoles.includes(getUserSelectedRole() || "");
  const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({
    payPalTransactionId: "",
    transctionDate: "",
  });
  const [itemsList, setItemList] = useState<any[]>([]);
  const [showSuccessComponent, setShowSuccessComponent] =
    useState<boolean>(false);
  const [receiptID, setReceiptID] = useState<string>("");
  const [userID, setUserID] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [isDatePickerOpen, setDatePickerOpen] = useState(false);

  const [donationPurposeItems, setDonationPurposeItems] = useState([]);
  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.purposeOfDonations,
      // includeToken: true,
    })
      .then((res) => {
        setDonationPurposeItems(res.data);
      })
      .catch((err) => {
        console.log(err, "donationerrorrrrr");
      });
  }, []);

  useEffect(() => {
    const storedCartItems = sessionStorage.getItem("cartItems");
    if (storedCartItems) {
      const cartItemObjects = JSON.parse(storedCartItems);
      setItemList(cartItemObjects);
    }
  }, []);

  const validationSchema = object().shape({
    payPalTransactionId: string().required("PayPal Transaction Id is required"),
    transctionDate: string().required("Transaction Date is required"),
  });

  const [formData, setFormData] = useState({
    payPalTransactionId: "",
    transctionDate: "",
    totalAmount: "",
  });

  function convertToISODate(dateString:any) {
    const [month, day, year] = dateString.split('-');
    const dateObject = new Date(`${year}-${month}-${day}`);
    const isoFormat = dateObject.toISOString();
    return isoFormat;
}


  const [openPaymentCancelDialog, setOpenPaymentCancelDialog] = useState(false);

  const handleClose = () => {
    setOpenPaymentCancelDialog(false);
  };

  const handleCancel = () => {
    setFormData({
    payPalTransactionId: "",
      transctionDate: "",
      totalAmount: "",
    });
    setOpenPaymentCancelDialog(false);
    props?.navigateBack?.();
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  const handleFieldChange = (field: string, value: any) => {
    if (field === "transctionDate") {
      const formattedDate = dayjs(value, "MM-DD-YYYY");
      setDatePickerOpen(false);
      setFormData({
        ...formData,
        [field]: formattedDate.isValid()
          ? formattedDate.format("MM-DD-YYYY")
          : "",
      });
    } else {
      setFormData({
        ...formData,
        [field]: value,
      });
    }
  };

  const handleDatePickerClick = () => {
    setDatePickerOpen(true);
  };

  useEffect(() => {
      setDatePickerOpen(false);
    }, [formData.transctionDate]);

  const handleSave = async (): Promise<void> => {
    const errors: ErrorMessageTypes = {
    payPalTransactionId: "",
    transctionDate: "",
    };

    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(formData, { abortEarly: false });
      // If validation passes, you can submit the form
      setErrorMessage(errors);
      // alert('Registration Successful');
      // Call your API or perform other actions here
      saveApiCall();
      // console.log("Register Successful")
    } catch (error: any) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e: any) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypes] = e.message;
          }
        });
      }
      setErrorMessage(errors);
    }
  };
  const getAccountNumberByDescription = (donationPurposeItems: any, description: string) => {
    for (let account of donationPurposeItems) {
      if (account.accountDescription === description) {
        return account.accountNumber;
      }
    }
    // Return null if the account description is not found
    return null;
  };

  let mappedItems: {
    donationpurposeid: number;
    amount: number;
    itemId: number
    description: string;
    modeOfPayment: number
  }[] = [];

  // Iterate over each item in bookedItemInCart
  props.cartItemsList?.forEach((item:any) => {
    // Create a new object to hold the mapped fields
    let mappedItem = {} as {
      donationpurposeid: number;
      amount: number;
      itemId: number
      description: string;
      modeOfPayment: number
    };

    // Map the dynamic fields
    mappedItem.donationpurposeid = getAccountNumberByDescription(donationPurposeItems, item.donationPurpose);
    mappedItem.amount = item.amount;
    mappedItem.itemId = item.id;
    mappedItem.description = item.description;
    mappedItem.modeOfPayment = 33
    mappedItems.push(mappedItem);
  });

  const saveApiCall = () => {
    setLoading(true);
    let payloadForAddToCart = {
        paypalDetails: {
          paypalId: formData.payPalTransactionId,
          amount: props.amount,
          transactionDate: new Date(convertToISODate(formData.transctionDate)).getTime()
        },
        items: mappedItems,
        modeOfPayment: 33
      };
      apiRequest({
        method: "POST",
        endpoint: apiPath.cartPayment,
        includeToken: true,
        body: JSON.stringify(payloadForAddToCart)
      })
        .then((res) => {
          sessionStorage.setItem("showPaymentStatus", JSON.stringify(true));
          navigate(`/receipt?receiptID=${res.data.receiptId}&userID=${res.data.userId}`);

        })
        .catch((err) => {
          console.log(err)
        })
  };

  const handleButtons = () => {
    return (
      <div style={{ display: "flex", gap: "10px" }}>
        <CommonOutlinedButton
          className={commonStyles.cancelButton}
          onClick={() => setOpenPaymentCancelDialog(true)}
        >
          Cancel
        </CommonOutlinedButton>
        <CommonButton className={commonStyles.saveButton} onClick={handleSave} disabled={loading}>
        {loading ? (
                <>
                  <ClipLoader color="#fff" loading={loading} size={15} />
                  <span
                    style={{
                      marginLeft: "8px",
                      fontSize: "15px",
                      textAlign: "center",
                    }}
                  >
                    Loading...
                  </span>
                </>
              ) : (
                "Make Payment"
              )}
        </CommonButton>
      </div>
    );
  };

  const DatePicker = (): React.ReactElement => {
    return (
      <div style={{ borderRadius: "8px" }}>
        <StyledDateContainer
        onClick={handleDatePickerClick}
          sx={{
            backgroundColor: "#FFF9E4",
            borderRadius: "8px",
            height: "48px",
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
               open={isDatePickerOpen}
               onClose={() => setDatePickerOpen(false)}
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  formData.transctionDate
                    ? dayjs(formData.transctionDate, "MM-DD-YYYY")
                    : ""
                }
                disableFuture={true}
                onChange={(value) => {
                  setErrorMessage({ ...errorMessage, transctionDate: "" });
                  handleFieldChange("transctionDate", value);
                }}
                className={
                  errorMessage.transctionDate
                    ? styles.errorTextField
                    : styles.textField
                }
              />
            </DemoContainer>
          </LocalizationProvider>
          {errorMessage.transctionDate ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.transctionDate}
            </Typography>
          ) : (
            ""
          )}
        </StyledDateContainer>
      </div>
    );
  };

  const paymentComponent = () => {
    return (
      <div className={styles.ChequeContainer} style={{width:"100%", marginTop:"20px"}}>
        <Box className={styles.backArrow}>
          <Typography className={styles.heading} sx={{fontSize:"20px"}}>PayPal Details</Typography>
        </Box>
        <Card className={styles.formContainer}>
          <Grid container spacing={2}>
            <Grid xs={12} sm={4} item sx={{ marginRight: "40px" }}>
              {CustomRequiredInputLabel("PayPal Transaction Id", true)}
              <CustomTextFeild
                fullWidth
                required
                value={formData.payPalTransactionId}
                onChange={(e) => {
                  setErrorMessage({ ...errorMessage, payPalTransactionId: "" });
                  handleFieldChange("payPalTransactionId", e.target.value);
                }}
                className={
                  errorMessage.payPalTransactionId
                    ? styles.errorTextField
                    : styles.textField
                }
                placeholder="PayPal Transaction Id"
              />
              {errorMessage.payPalTransactionId && (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {errorMessage.payPalTransactionId}
                </Typography>
              )}
            </Grid>
            <Grid xs={12} sm={4} item sx={{ marginRight: "40px" }}>
              {CustomRequiredInputLabel("Transaction Date", true)}
              {DatePicker()}
            </Grid>
            {/* <Grid xs={12} sm={4} item sx={{ marginRight: "40px" }}>
              {CustomRequiredInputLabel("Total Amount", false)}
              <CustomTextFeild
                fullWidth
                required
                value={props.amount}
                disabled={true}
                placeholder="Total Amount"
              />
            </Grid> */}
          </Grid>
        </Card>
        <div>{handleButtons()}</div>
      </div>
    );
  };

  return (
    <>
      <Toaster />
      {hasManagerLevelRole && <>{paymentComponent()}</>}
      <PaymentCancelConfirmationDialog isOpen={openPaymentCancelDialog} handleClose={handleClose} handleCancel={handleCancel}/>
    </>
  );
}
